var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.93162 16.8089H13.2678V15.1159H5.93162V16.8089ZM5.93162 12.2943H16.6537V10.6013H5.93162V12.2943ZM5.93162 7.77973H16.6537V6.08677H5.93162V7.77973ZM3.73952 21.0413C3.16937 21.0413 2.68678 20.8438 2.29176 20.4487C1.89673 20.0537 1.69922 19.5711 1.69922 19.001V3.89467C1.69922 3.32452 1.89673 2.84193 2.29176 2.44691C2.68678 2.05188 3.16937 1.85437 3.73952 1.85437H18.8458C19.416 1.85437 19.8986 2.05188 20.2936 2.44691C20.6886 2.84193 20.8861 3.32452 20.8861 3.89467V19.001C20.8861 19.5711 20.6886 20.0537 20.2936 20.4487C19.8986 20.8438 19.416 21.0413 18.8458 21.0413H3.73952ZM3.73952 19.3483H18.8458C18.9327 19.3483 19.0123 19.3121 19.0845 19.2397C19.1569 19.1674 19.1932 19.0879 19.1932 19.001V3.89467C19.1932 3.80777 19.1569 3.7282 19.0845 3.65596C19.0123 3.58354 18.9327 3.54733 18.8458 3.54733H3.73952C3.65261 3.54733 3.57304 3.58354 3.50081 3.65596C3.42839 3.7282 3.39218 3.80777 3.39218 3.89467V19.001C3.39218 19.0879 3.42839 19.1674 3.50081 19.2397C3.57304 19.3121 3.65261 19.3483 3.73952 19.3483Z",
    fill: "#C8D0D5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInvoice);
export default __webpack_public_path__ + "static/media/icon_invoice.741a85056b4cb9e551e9fcb922969bb9.svg";
export { ForwardRef as ReactComponent };